// @ts-ignore esModuleInterop
import React from 'react'
import type {
  primitives,
  AuctionBlueprintScheduledOnlineReactiveArgs,
  // @ts-ignore no types
} from '@adc/blueprint'
import type { Maybe, Property } from '@adc/sdk/types'
// @ts-ignore no types
import { hooks } from '@adc/ui-adc'
// @ts-ignore no types
import PropertyProvider, {
  PropertyPageActionsType,
} from 'common/context/property'
import PropertyHeader from '../modules/propertyHeader'
import MessagesBanner from '../modules/messagesBanner'
import PropertyDetails from '../modules/propertyDetails'
import Breadcrumbs from '../modules/breadcrumbs'
import Documents from '../modules/documents'
import { Faqs } from '../modules/faqs'
import InvestmentInfo from '../modules/investmentInfo'
import TransactionDetails from '../modules/transactionDetails'
import SimilarPropertiesCarousel from '../modules/similarProperties'
import AuctionDetails from '../modules/auctionDetails'
import DueDiligence from '../modules/dueDiligence'
import { StickyHeader } from '../modules/stickyHeader'
import HelpCenter from '../modules/helpCenter'
import { ConnectedCompSales } from '../modules/compsales'
import SeoLinksFooter from '../modules/seoLinksFooter'
import Disclaimer from '../modules/disclaimer'
import { CombinedListingType, ListingProvider } from '../context/listing'
import ActivePropertyWrapperContainer, {
  ApplicationBidBanner,
} from './activePropertyWrapper'

type AuctionUser = primitives.AuctionUser

interface DefaultPropertyContentProps {
  segment: AuctionBlueprintScheduledOnlineReactiveArgs['segment']
  listing: CombinedListingType
  pageBannerRef: any
  user: AuctionUser
  isOnline: Maybe<boolean> | undefined
  property: Property
  propertyActions: PropertyPageActionsType
}

const DefaultPropertyContent = ({
  segment,
  listing,
  pageBannerRef,
  user,
  isOnline,
  property,
  propertyActions,
}: DefaultPropertyContentProps) => {
  const { useIsMobileHook } = hooks
  const isMobile = useIsMobileHook()

  // TODO: check if segment is used in any components that assume it's live auction segment and point those to live_segment instead, once sure it's safe, change segment to only populate if it's OnlineAuctionSegment typename
  return (
    <PropertyProvider property={property} propertyActions={propertyActions}>
      <ListingProvider listing={listing} segment={segment}>
        <StickyHeader />
        {!isMobile && <Breadcrumbs />}
        <MessagesBanner pageBannerRef={pageBannerRef} />
        <ApplicationBidBanner listing={listing} segment={segment} />
        <PropertyHeader />
        <InvestmentInfo />
        <AuctionDetails />
        <PropertyDetails key={String(user.logged_in)} />
        {/* @ts-ignore js redux file */}
        <SimilarPropertiesCarousel />
        <ConnectedCompSales />

        {/* @ts-ignore segment type is wrong */}
        <DueDiligence segment={segment} isOnline={isOnline} />
        <Documents />
        <Faqs />
        <TransactionDetails />
        <HelpCenter />
        <Disclaimer />
        {isMobile && <Breadcrumbs />}
        <SeoLinksFooter />
      </ListingProvider>
    </PropertyProvider>
  )
}

interface FunctionalPropertyContainerProps {
  pageBannerRef: any
}

const FunctionalPropertyContainer = (
  props: FunctionalPropertyContainerProps
) => {
  return (
    <ActivePropertyWrapperContainer
      {...props}
      childComponent={DefaultPropertyContent}
    />
  )
}

export default FunctionalPropertyContainer
